export default __webpack_public_path__ + "static/navImg1-5ca4645b236fe88e422ff10b5d8d55d1.jpg";